// --- Distance and Fee Calculation ---
function haversineKm(a, b) {
  if (!a || !b || a.lat == null || a.lng == null || b.lat == null || b.lng == null) return null;
  const R = 6371; // km
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const s = Math.sin(dLat/2)**2 + Math.sin(dLon/2)**2 * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  return R * c; // km
}

// Function to round kilometers based on mode
function roundKm(value, mode = 'nearest') {
  if (mode === 'ceil')  return Math.ceil(value * 1000) / 1000;
  if (mode === 'floor') return Math.floor(value * 1000) / 1000;
  return Math.round(value * 1000) / 1000;
}

// Function to compute the delivery fee based on distance and rule
function computeKilometerFee(rule, distanceKmRaw) {
  const multiplier       = Number(rule?.distance_multiplier || 1);
  const baseKm           = Number(rule?.base_km_included || 0);
  const rate             = Number(rule?.per_km_rate || 0);
  const kmRounding       = rule?.km_rounding || 'nearest';
  const minFee           = rule?.min_fee != null ? Number(rule.min_fee) : null;
  const maxFee           = rule?.max_fee != null ? Number(rule.max_fee) : null;

  const distanceEff      = (distanceKmRaw ?? 0) * multiplier;
  const extraKmRaw       = Math.max(0, distanceEff - baseKm);
  const kmCobrables      = roundKm(extraKmRaw, kmRounding);
  let fee                = rate * kmCobrables;

  if (minFee != null) fee = Math.max(fee, minFee);
  if (maxFee != null) fee = Math.min(fee, maxFee);

  return {
    distance_km_raw: distanceKmRaw != null ? Number(distanceKmRaw.toFixed(3)) : null,
    distance_km_effective: Number(distanceEff.toFixed(3)),
    km_cobrables: Number(kmCobrables.toFixed(3)),
    fee: Number((Math.round(fee * 100) / 100).toFixed(2))
  };
}

// --- Zone (polygon) coverage resolution ---
// Ray-casting point-in-polygon test, no external dependency (same criteria as haversineKm above).
function pointInPolygon(point, polygon) {
    if (!point || point.lat == null || point.lng == null || !Array.isArray(polygon) || polygon.length < 3) return false;

    const x = point.lng, y = point.lat;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].lng, yi = polygon[i].lat;
        const xj = polygon[j].lng, yj = polygon[j].lat;

        const intersect = ((yi > y) !== (yj > y)) &&
            (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

        if (intersect) inside = !inside;
    }

    return inside;
}

// Function to resolve which zone (if any) of a fee_type = 'zone' rule contains the given point.
// Returns { fee, zone_id, zone_name } for the first matching zone (ordered by priority, lowest first), or null if out of coverage.
function resolveZoneFee(rule, point) {
    const zones = Array.isArray(rule?.zones) ? rule.zones : [];
    if (!point || point.lat == null || point.lng == null || zones.length === 0) return null;

    const sortedZones = [...zones].sort((a, b) => Number(a.priority ?? 100) - Number(b.priority ?? 100));

    for (const zone of sortedZones) {
        if (pointInPolygon(point, zone.polygon)) {
            return {
                fee: Number(zone.price || 0),
                zone_id: zone.id,
                zone_name: zone.name
            };
        }
    }

    return null;
}

export {
    haversineKm,
    roundKm,
    computeKilometerFee,
    pointInPolygon,
    resolveZoneFee
}